<script lang="ts" setup>
import { storeToRefs } from 'pinia'

import { TOP_CONTENT_VISIBLE_ROUTES } from '@/constants/topContentVisibleRoutes'

import { useBasketMethods } from '@/composables/useBasketMethods'
import { useContentVisibleByRoute } from '@/composables/useContentVisibleByRoute'
import { useVkAuth } from '@/composables/useVkAuth'

import { useAddressSystemStore } from '@/store/addressSystem'
import { useToggleStore } from '@/store/toggle/toggle'

import { VkAuthType } from '@/services/vk/types'

import TheCookiesBanner from '@/components/App/AppCookiesBanner.vue'
import AppDialogs from '@/components/App/AppDialogs.vue'
import AppScrollUp from '@/components/App/AppScrollUp.vue'
import TheFooter from '@/components/Footer/TheFooter.vue'
import TheHeader from '@/components/Header/TheHeader.vue'

const MainCategoryList = defineAsyncComponent({
  loader: () => import('@/components/Main/MainCategoryList.vue'),
  suspensible: false,
})
const AppSnackbar = defineAsyncComponent(
  () => import('@/components/App/AppSnackbar.vue'),
)
const MainDialogWorking = defineAsyncComponent(
  () => import('@/components/Main/MainDialogWorking.vue'),
)

const { isVisibleStories, isLandingPageEnabled } = storeToRefs(useToggleStore())

const { handleRedirectCity } = useBasketMethods()

const route = useRoute()

const { setVisibleAddressSystemDialog } = useAddressSystemStore()
const { isVisibleAddressSystemDialog } = storeToRefs(useAddressSystemStore())

const { isVisible } = useContentVisibleByRoute(TOP_CONTENT_VISIBLE_ROUTES)

const closeAddressSystemDialog = () => {
  setVisibleAddressSystemDialog(false)
  isVisibleAddressSystemDialog.value = false
}

onMounted(async () => {
  await handleRedirectCity()

  useVkAuth(VkAuthType.Window)
})
</script>

<template>
  <div class="default">
    <the-header />

    <main class="default__wrapper">
      <app-stories v-if="isVisible && isVisibleStories" />

      <main-category-list
        v-if="isVisible && !isLandingPageEnabled"
        class="default__categories"
      />

      <div class="page" :class="[`page--${String(route.name)}`]">
        <slot />
      </div>

      <main-dialog-working />

      <address-system-dialog
        v-if="isVisibleAddressSystemDialog"
        :model-value="isVisibleAddressSystemDialog"
        @update:model-value="closeAddressSystemDialog"
      />
    </main>

    <the-footer />

    <client-only>
      <the-cookies-banner />
    </client-only>

    <app-dialogs />
    <app-snackbar />
    <app-scroll-up />
  </div>
</template>

<style lang="scss" scoped>
.default {
  background: var(--ui-color-white);

  &__categories {
    max-width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
  }

  &__wrapper {
    position: relative;
  }

  :deep(.page) {
    &:not(.page--product-product):not(.page--category-category) {
      min-height: calc(100vh - 118px);
    }
  }
}
</style>
